var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMapMarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-map-market",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.864,
    height: 23.818,
    viewBox: "0 0 17.864 23.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "map-marker-alt-solid",
    d: "M8.014,23.338C1.255,13.539,0,12.533,0,8.932a8.932,8.932,0,1,1,17.864,0c0,3.6-1.255,4.607-8.014,14.406a1.117,1.117,0,0,1-1.836,0Zm.918-10.684A3.722,3.722,0,1,0,5.21,8.932,3.722,3.722,0,0,0,8.932,12.654Z",
    fill: "#146f62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMapMarket);
export default __webpack_public_path__ + "static/media/ic-map-market.9a14074d56c2d4053ed0b168fc808229.svg";
export { ForwardRef as ReactComponent };